import { styled } from '@mui/material/styles';
import { ButtonGroup } from '@mui/material';
import { FILTER_HEIGHT } from 'global/components/AssessmentFilters/styles';

export const ScorecardToggleGroup = styled(ButtonGroup)(({ theme }) => ({
  flexShrink: 0,
  height: FILTER_HEIGHT,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  marginLeft: theme.spacing(1),
  boxShadow: 'none',
  '@media print': {
    display: 'none',
  },
  '& .MuiButton-root': {
    height: FILTER_HEIGHT,
    minHeight: FILTER_HEIGHT,
  },
}));
